import _objectSpread from "C:\\Users\\Himanshu\\OneDrive\\Desktop\\Portfolio Website\\portfolio-website\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/objectSpread";
import _objectWithoutProperties from "C:\\Users\\Himanshu\\OneDrive\\Desktop\\Portfolio Website\\portfolio-website\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/objectWithoutProperties";
import * as React from 'react';
import Tabs from '@restart/ui/Tabs';
import getTabTransitionComponent from './getTabTransitionComponent';
import { jsx as _jsx } from "react/jsx-runtime";
var TabContainer = function TabContainer(_ref) {
  var transition = _ref.transition,
    props = _objectWithoutProperties(_ref, ["transition"]);
  return /*#__PURE__*/_jsx(Tabs, _objectSpread({}, props, {
    transition: getTabTransitionComponent(transition)
  }));
};
TabContainer.displayName = 'TabContainer';
export default TabContainer;